function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import './Likert.css';
import whitelistProps from '../../utils/whitelistProps';
import noop from '../../utils/noop';
import cs from 'classnames';
import withInputContainer from '../withInputContainer/withInputContainer';
import FormLabel from '../FormLabel/FormLabel';
import Radiogroup from '../Radiogroup';
import ThemeContext from '../../ThemeContext';
var whitelist = whitelistProps();
export function Likert(_ref) {
  var options = _ref.options,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type,
    auto = _ref.auto,
    description = _ref.description,
    errorId = _ref.errorId,
    errorMsg = _ref.errorMsg,
    width = _ref.width,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    id = _ref.id,
    value = _ref.value,
    checked = _ref.checked,
    name = _ref.name,
    style = _ref.style,
    required = _ref.required,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    attrs = _objectWithoutProperties(_ref, ["options", "type", "auto", "description", "errorId", "errorMsg", "width", "size", "id", "value", "checked", "name", "style", "required", "disabled", "readonly", "onBlur", "onChange", "onFocus"]);
  var styl = width ? Object.assign({}, style, {
    width: width
  }) : style;
  var len = options.length;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    className: cs('_dm-likert-scale__options', "_dm-likert-scale__options--".concat(size), "_dm-likert-scale__options--".concat(theme), "_dm-likert-scale__options--".concat(theme, "--").concat(size), 'auto-likert-scale')
  }, options.map(function (option) {
    var key = "".concat(id, "-").concat(option.value);
    return /*#__PURE__*/React.createElement("span", {
      key: key,
      className: cs('_dm-likert-scale__option', "_dm-likert-scale__option--".concat(len), "_dm-likert-scale__option--".concat(size), "_dm-likert-scale__option--".concat(size, "--").concat(len), "_dm-likert-scale__option--".concat(theme), "_dm-likert-scale__option--".concat(theme, "--").concat(size), "_dm-likert-scale__option--".concat(theme, "--").concat(size, "--").concat(len))
    }, /*#__PURE__*/React.createElement("input", Object.assign({
      id: key,
      value: option.value,
      checked: value === option.value,
      "aria-checked": value === option.value,
      name: name || id,
      className: cs("_dm-input _dm-input--".concat(size), "_dm-input--likert _dm-input--likert--".concat(size), "_dm-input--likert--".concat(theme), "auto-boolean-input auto-".concat(type, "-input"), _defineProperty({}, auto, auto)),
      type: type,
      role: "radio",
      style: styl,
      required: required,
      disabled: disabled,
      "aria-disabled": disabled,
      onBlur: onBlur,
      onChange: readonly ? noop : onChange,
      onFocus: onFocus,
      "aria-describedby": errorId,
      "aria-invalid": !!errorMsg,
      "aria-errormessage": errorId
    }, whitelist(attrs))), /*#__PURE__*/React.createElement(FormLabel, {
      htmlFor: key,
      i18n: option.label,
      type: "likert",
      size: "likert"
    }));
  }));
}
export default withInputContainer({
  type: 'likert',
  // fieldsets can't be grid containers, so we must put a div as a direct child
  // to take on the role of input container
  // see: https://github.com/rachelandrew/gridbugs#10-some-html-elements-cant-be-grid-containers
  element: Radiogroup,
  role: 'radiogroup'
})(Likert);